module.exports = __webpack_public_path__ + "img/8.9e9413d7.png";